import { render, staticRenderFns } from "./Sprachen.vue?vue&type=template&id=7ad2924b&scoped=true&"
import script from "./Sprachen.vue?vue&type=script&lang=js&"
export * from "./Sprachen.vue?vue&type=script&lang=js&"
import style0 from "./Sprachen.vue?vue&type=style&index=0&id=7ad2924b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad2924b",
  null
  
)

export default component.exports